var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickRange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H2V6H6V2Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 2C1.25 1.58579 1.58579 1.25 2 1.25H6C6.41421 1.25 6.75 1.58579 6.75 2V6C6.75 6.41421 6.41421 6.75 6 6.75H2C1.58579 6.75 1.25 6.41421 1.25 6V2ZM2.75 2.75V5.25H5.25V2.75H2.75Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18H18V22H22V18Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18C17.25 17.5858 17.5858 17.25 18 17.25H22C22.4142 17.25 22.75 17.5858 22.75 18V22C22.75 22.4142 22.4142 22.75 22 22.75H18C17.5858 22.75 17.25 22.4142 17.25 22V18ZM18.75 18.75V21.25H21.25V18.75H18.75Z",
    fill: "#1C1B1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H2V22H6V18Z",
    fill: "#1C1B1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 18C1.25 17.5858 1.58579 17.25 2 17.25H6C6.41421 17.25 6.75 17.5858 6.75 18V22C6.75 22.4142 6.41421 22.75 6 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22V18ZM2.75 18.75V21.25H5.25V18.75H2.75Z",
    fill: "#1C1B1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2H18V6H22V2Z",
    fill: "#1C1B1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 2C17.25 1.58579 17.5858 1.25 18 1.25H22C22.4142 1.25 22.75 1.58579 22.75 2V6C22.75 6.41421 22.4142 6.75 22 6.75H18C17.5858 6.75 17.25 6.41421 17.25 6V2ZM18.75 2.75V5.25H21.25V2.75H18.75Z",
    fill: "#1C1B1E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.25C4.41421 5.25 4.75 5.58579 4.75 6V18C4.75 18.4142 4.41421 18.75 4 18.75C3.58579 18.75 3.25 18.4142 3.25 18V6C3.25 5.58579 3.58579 5.25 4 5.25Z",
    fill: "#1C1B1E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5.25C20.4142 5.25 20.75 5.58579 20.75 6V18C20.75 18.4142 20.4142 18.75 20 18.75C19.5858 18.75 19.25 18.4142 19.25 18V6C19.25 5.58579 19.5858 5.25 20 5.25Z",
    fill: "#1C1B1E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 4C5.25 3.58579 5.58579 3.25 6 3.25H18C18.4142 3.25 18.75 3.58579 18.75 4C18.75 4.41421 18.4142 4.75 18 4.75H6C5.58579 4.75 5.25 4.41421 5.25 4Z",
    fill: "#1C1B1E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 20C5.25 19.5858 5.58579 19.25 6 19.25H18C18.4142 19.25 18.75 19.5858 18.75 20C18.75 20.4142 18.4142 20.75 18 20.75H6C5.58579 20.75 5.25 20.4142 5.25 20Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickRange);
export default __webpack_public_path__ + "static/media/PickRange.1e440665.svg";
export { ForwardRef as ReactComponent };